function average(ctx) {
    let values = [];
    ctx.chart.data.datasets.forEach((dataset) => {
        dataset.data.forEach(dp => values.push(dp))
    })
    return values.reduce((a, b) => a + b, 0) / values.length;
}

function standardDeviation(ctx) {
    const values = ctx.chart.data.datasets[0].data;
    const n = values.length;
    const mean = average(ctx);
    return Math.sqrt(values.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n);
}

const meanAnnotation = {
    type: 'line',
    borderColor: 'rgb(100, 149, 237)',
    borderDash: [6, 6],
    borderDashOffset: 0,
    borderWidth: 3,
    label: {
        display: true,
        backgroundColor: 'rgb(100, 149, 237)',
        content: (ctx) => 'Average: ' + average(ctx).toFixed(2),
        position: 'bottom',

    },
    scaleID: 'y',
    value: (ctx) => average(ctx)
}
const plusSDAnnotation = {
    type: 'line',
    borderColor: 'rgba(102, 102, 102, 0.5)',
    borderDash: [6, 6],
    borderDashOffset: 0,
    borderWidth: 3,
    label: {
        display: true,
        backgroundColor: 'rgba(102, 102, 102, 0.5)',
        color: 'black',
        content: (ctx) => '+1 SD: ' + (average(ctx) + standardDeviation(ctx)).toFixed(2),
        position: 'start',
        // rotation: -90,
        // yAdjust: -28
    },
    scaleID: 'y',
    value: (ctx) => average(ctx) + standardDeviation(ctx)
}
const minusSDAnnotation = {
    type: 'line',
    borderColor: 'rgba(102, 102, 102, 0.5)',
    borderDash: [6, 6],
    borderDashOffset: 0,
    borderWidth: 3,
    label: {
        display: true,
        backgroundColor: 'rgba(102, 102, 102, 0.5)',
        color: 'black',
        content: (ctx) => '-1 SD: ' + (average(ctx) - standardDeviation(ctx)).toFixed(2),
        position: 'end',
        // rotation: 90,
        // yAdjust: 28
    },
    scaleID: 'y',
    value: (ctx) => average(ctx) - standardDeviation(ctx)
}

const dayAnnotation = (value) => {
    return {
        type: 'line',
        borderColor: 'rgba(102, 102, 102, 0.5)',
        borderDash: [10, 10],
        borderDashOffset: 0,
        borderWidth: 1,
        // label: {
        //     display: true,
        //     backgroundColor: 'rgba(102, 102, 102, 0.5)',
        //     color: 'black',
        //     position: 'end',
        //     // rotation: 90,
        //     // yAdjust: 28
        // },
        scaleID: 'x',
        value: `${value}`
    }
}
const findAMorPM = (label)=>{
    if(typeof label !== "string")
        return
    if(label.includes("AM"))
        return "AM"
    if(label.includes("PM"))
        return "PM"
}
export const getDayAnnotations = (labels) => {
    let annotations = []
    let last = findAMorPM(labels[0])

    for(let i = 0; i < labels.length; i++){
        const timestring = labels[i]
        const current = findAMorPM(timestring)
        if(!current) continue
        
        if(last === "PM" && current ==="AM"){
            annotations.push(dayAnnotation(timestring))
        }
        

        last = current
    }
    return annotations

}
export const standardDeviationAnnotations = [plusSDAnnotation, meanAnnotation, minusSDAnnotation]